<template>
    <div class="huiyuan">

        <h2>《会员服务条款》</h2>

        <div class="littlett">您只有无条件接受以下所有服务条款，才能继续申请</div>

        <h3>一、服务条款的确认和接纳</h3>

        <p class="ml">环球雅途易旅通的所有权和运作权归景区所有。用户通过完成注册程序并点击一下“我同意”的按钮，这表示用户与景区达成协议并接受所有的服务条款。</p>
        <h3>二、权利及义务</h3>
            <h4 class="ml">环球雅途易旅通的权利、义务</h4>
                <h5 class="ml">1、用户隐私制度</h5>
                    <div>
                        <p class="mb ml1">尊重会员个人隐私是环球雅途易旅通的基本政策，环球雅途易旅通不会公开、编辑或透露会员的注册资料，除非符合以下情况： </p>
                        <p class="lh mb ml1">（1）遵守有关法律规定，包括在国家有关机关查询时，提供用户在环球雅途易旅通的网页上发布的信息内容及其发布时间、互联网地址或者域名。<br>
                            （2） 维护环球雅途易旅通的商标所有权及其它权益。<br>
                            （3）在紧急情况下竭力维护会员个人、其它社会个体和社会大众的安全。<br>
                            （4）根据相关规定或者环球雅途易旅通认为必要的其他情况下。<br>
                            （5）在使用环球雅途易旅通的某一项或多项服务时，会员同意公开自己的注册资料。</p>
                        <p class="ml1">如果会员提供的资料包含有不正确的信息，环球雅途易旅通保留结束会员使用网络服务资格的权利。</p>
                    </div>
                <h5 class="ml">2、服务内容的所有权</h5>
                    <div class="lh ml1">环球雅途易旅通定义的服务内容包括：文字、软件、声音、图片、录象、图表、广告中的全部内容；电子邮件的全部内容；环球雅途易旅通为会员提供的其他信息。所有这些内容受版权、商标及其它财产所有权法律的保护。所以，会员只能在环球雅途易旅通和广告商授权下才能使用这些内容，而不能擅自复制、再造这些内容、或创造与内容有关的派生产品。任何人需要转载环球雅途易旅通的文章、数据，必须征得原文作者或环球雅途易旅通授权。
                    </div>
                <h5 class="ml">3、会员管理</h5>
                    <div class="ml1">
                        环球雅途易旅通对会员的管理依据国家法律、地方法律和国际法律等标准。
                    </div>
                <h5 class="ml" >4、对会员信息的存储和限制</h5>
                    <div class="mb ml1">
                        环球雅途易旅通不对会员所发布信息的删除或储存失败负责。环球雅途易旅通有判定会员的行为是否符合环球雅途易旅通服务条款的要求和精神的保留权利，如果会员违背了服务条款的规定，环球雅途易旅通有权选择适当的处理方法直至中断对其提供网络服务的权利。
                    </div>
            <h4 class="ml">会员权利义务：</h4>
                <h5 class="ml">1、 会员的权利：</h5>
                    <div>
                        <p class="mb ml1">（1）普通会员：</p>
                        <div class="lh mb ml2">
                            第一． 预订环球雅途易旅通上的景区门票、酒店、餐厅及旅游线路等服务，论坛发帖。<br>
                            第二．有权获得环球雅途易旅通提供的便捷服务或价格优惠。
                        </div>
                        <p class="mb ml1">（2）团体会员（旅行社）：</p>
                        <div class="lh mb ml2">
                            第一．预订环球雅途易旅通上的景区门票、酒店、餐厅及旅游线路等服务，论坛发帖；<br>
                            第二．享受网上预订的团体价格；<br>
                            第三．根据网上预订优惠政策，享受相关优惠及奖励；<br>
                            第四．团体会员注册后需审核身份后方能进行交易。
                        </div>
                        <p class="mb ml1">（3）团体会员（导游）：</p>
                        <div class="lh mb ml2">
                            第一．预订环球雅途易旅通上的景区门票、酒店、餐厅及旅游线路等服务，论坛发帖；<br>
                            第二．享受网上预订的团体价格；<br>
                            第三．根据网上预订优惠政策，享受相关优惠及奖励；<br>
                            第四．团体会员注册后需审核身份后方能进行交易。
                        </div>
                    </div>
                <h5 class="ml">2、用户单独承担发布内容的责任。用户对服务的使用是根据所有适用于服务的地方法律、国家法律和国际法律标准的。用户承诺：</h5>
                    <div>
                        <P class="mb ml1">（1）在环球雅途易旅通的网页上发布信息或者利用环球雅途易旅通的服务时必须符合中国有关法规，不得在环球雅途易旅通的网页上或者利用环球雅途易旅通的服务制作、复制、发布、传播以下信息：</P>
                        <div class="lh mb ml2">
                            (a)反对宪法所确定的基本原则的；<br>
                            (b) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
                            (c) 损害国家荣誉和利益的；<br>
                            (d) 煽动民族仇恨、民族歧视，破坏民族团结的；<br>
                            (e) 破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
                            (f) 散布谣言，扰乱社会秩序，破坏社会稳定的；<br>
                            (g) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
                            (h) 侮辱或者诽谤他人，侵害他人合法权益的；<br>
                            (i) 含有法律、行政法规禁止的其他内容的。
                        </div>
                        <p class="mb ml1">
                            （2）在环球雅途易旅通的网页上发布信息或者利用环球雅途易旅通的服务时还必须符合其他有关国家和地区的法律规定以及国际法的有关规定。
                        </p>
                        <p class="mb ml1">
                            （3）不利用环球雅途易旅通的服务从事以下活动：
                        </p>
                        <div class="lh mb ml2">
                            (a) 未经允许，进入计算机信息网络或者使用计算机信息网络资源的；<br>
                            (b) 未经允许，对计算机信息网络功能进行删除、修改或者增加的；<br>
                            (c) 未经允许，对进入计算机信息网络中存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；<br>
                            (d) 故意制作、传播计算机病毒等破坏性程序的；<br>
                            (e) 其他危害计算机信息网络安全的行为。
                        </div>
                        <p class="mb ml1">（4）不以任何方式干扰环球雅途易旅通的服务。</p>
                        <p class="mb ml1">（5）遵守环球雅途易旅通的所有其他规定和程序。</p>
                        <p class="mb ml1">用户需对自己在使用环球雅途易旅通服务过程中的行为承担法律责任。用户理解，如果环球雅途易旅通发现其网站传输的信息明显属于上段第(1)条所列内容之一，依据中国法律，环球雅途易旅通有义务立即停止传输，保存有关记录，向国家有关机关报告，并且删除含有该内容的地址、目录或关闭服务器。</p>
                    </div>
                <h5 class="ml">3、基于网络服务的特性及重要性，会员同意：</h5>
                    <p class="lh ml1">(1)提供详尽、准确的个人资料。<br>
                        (2)不断更新注册资料，符合及时、详尽、准确的要求。<br>
                        (3)自行配备上网的所需设备， 包括个人电脑、调制解调器或其他必备上网装置。<br>
                        (4)自行负担个人上网所支付的与此服务有关的电话费用、 网络费用。</p>
                <h5 class="ml">4、会员的帐号、密码和安全性 </h5>
                     <p class="ml1">会员一旦注册成功，成为环球雅途易旅通的合法会员，将得到一个密码和会员名。会员对自己的会员名、密码和安全将负全部责任。另外，每个会员都要对以其会员名进行的所有活动和事件负全责。
            会员同意若发现任何非法使用该用户名或其它有损用户利益的情况，立即通告环球雅途易旅通。环球雅途易旅通在应用户要求并且确认用户个人信息的情况下，可以对用户密码进行更改并及时通知用户。用户亦可在输入正确资料后，自己更改密码。每个会员都要对以其会员名进行的所有活动和事件负全责。</p>
                <h5 class="ml">5、会员发布宣传及广告信息</h5>
                    <p class="ml1">会员在他们发表的信息中加入宣传资料或参与广告策划，在环球雅途易旅通的所提供的收费和免费服务上展示他们的作品或商品，任何这类促销方法，包括运输货物、付款、服务、商业条件、担保及与广告有关的描述都只是在相应的会员和广告销售商之间发生。环球雅途易旅通不承担任何责任，环球雅途易旅通没有义务为这类广告销售负任何一部分的责任。会员需要对此承担全部责任。</p>
                <h5 class="ml">6、会员同意保障和维护环球雅途易旅通全体成员的利益，负责支付由会员使用超出服务范围引起的律师费用，违反服务条款的损害补偿费用等。</h5>
        <h3>三、关于担保</h3>
        <p class="lh ml">环球雅途易旅通明确表示不作任何类型的担保，不论是明确的或隐含的，但是不对商业性的隐含担保、特定目的和不违反规定的适当担保作限制。环球雅途易旅通不担保服务一定能满足会员的要求，也不担保服务不会受中断，对服务的及时性，安全性，出错发生都不作担保。环球雅途易旅通拒绝提供任何担保，由会员自己承担系统受损或资料丢失的所有风险和责任。环球雅途易旅通对在互联网上得到的任何商品购物服务或交易进程，都不作担保。会员不会从环球雅途易旅通收到口头或书面的意见或信息，也不会在这里作明确担保。 </p>
        <h3>四、关于责任</h3>
        <p class="ml">
            环球雅途易旅通对任何直接、间接、偶然、特殊及继起的损害不负责任，这些损害可能来自：他人的行为、会员不正当使用网络服务，在网上购买商品或进行同类型服务，在网上进行交易，非法使用网络服务或用户传送的信息有所变动。都有可能会导致环球雅途易旅通的形象受损，所以环球雅途易旅通事先提出这种损害的可能性。
        </p>
        <h3>五、服务条款的修改和服务修订</h3>
        <p class="ml">
            环球雅途易旅通有权在必要时修改服务条款，环球雅途易旅通服务条款一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容，会员可以主动取消获得的网络服务。如果会员继续享用网络服务，则视为接受服务条款的变动。环球雅途易旅通保留随时修改或中断服务而不需通知用户的权利。环球雅途易旅通行使修改或中断服务的权利，不需对用户或第三方负责。
        </p>
        <h3>六、通告</h3>
        <p class="ml">所有发给会员的通告都可通过重要页面的公告或电子邮件或常规的信件传送。服务条款的修改、服务变更、或其它重要事件的通告都会以此形式进行。</p>
        <h3>七、终止服务</h3>
        <p class="lh ml">会员或环球雅途易旅通可随时根据实际情况中断一项或多项网络服务。环球雅途易旅通不需对任何个人或第三方负责而随时中断服务。会员对后来的条款修改有异议，或对环球雅途易旅通的服务不满，可以行使如下权利：</p>
        <p class="lh ml">
            (1)停止使用环球雅途易旅通的网络服务。<br>
            (2)通告环球雅途易旅通停止对该会员的服务。

        </p>
        <p class="ml">结束会员服务后，会员使用网络服务的权利马上中止。从那时起，用户没有权利，环球雅途易旅通也没有义务传送任何未处理的信息或未完成的服务给用户或第三方。</p>
        <h3>八、法律管辖</h3>
        <p class="lh ml">网络服务条款要与中华人民共和国的法律解释相一致，会员和环球雅途易旅通一致同意服从中国法院管辖。如发生环球雅途易旅通服务条款与中华人民共和国法律相抵触时，则这些条款将完全按法律规定重新解释，而其它条款则依旧保持对会员产生法律效力和影响。</p>
    </div>
</template>

<script>
    export default {
        name: "membershipClause"
    }
</script>

<style scoped lang="less">
    .huiyuan{
        padding: 20px 22px;
        font: 14px SourceHanSansCN-Light;;
        color: #191919;
        height: 600px;
        overflow-y: auto;
    }
    .littlett{
        font:14px SourceHanSansCN-Light;
        color: #191919;
        text-align: center;
        margin: 20px;
    }
    h2{
        text-align: center;
    }
    h3{
        margin: 24px 0;
    }
    p{
        line-height: 18px;
    }
    h5{
        margin: 32px 0 16px;
        font-size: 14px;
    }
    .lh{
        line-height: 22px;
    }
    .mb{
        margin-bottom: 10px;
    }
    .ml{
        margin-left: 32px;
    }
    .ml1{
        margin-left: 53px;
    }
    .ml2{
        margin-left: 79px;
    }
</style>
